import request from '@/utils/request'
import axios from 'axios'
export function authUser(data: Record<string, any>) {
  return request({
    url: '/api/auth/user',
    method: 'post',
    data,
  })
}
